module.exports = __webpack_public_path__ + "img/feedback.5b8d7990.png";